// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3M_Tn","sendOtp":"AuthorizeToLogin_sendOtp__3EEqQ"};